export enum InquiryCustomCakeDeliveryType {
	PickUpCakovice = "PickUpCakovice",
	PickUpPetriny = "PickUpPetriny",
	DeliveryToAddress = "DeliveryToAddress",
}
